if (!customElements.get('sc-delivery-enquiry')) {
  customElements.define('sc-delivery-enquiry', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const input = this.querySelector('input');
      const message = this.querySelector('[role="status"]');
      const link = this.querySelector('[data-delivery-email]');
      input.addEventListener('input', () => {
        link.hidden = true;
        link.removeAttribute('href');
        message.textContent = '';
        input.removeAttribute('aria-invalid');
      });
      this.querySelector('button').addEventListener('click', () => {
        const pin = input.value.trim();
        if (!/^[1-9][0-9]{5}$/.test(pin)) {
          input.setAttribute('aria-invalid', 'true');
          message.textContent = 'Enter a 6-digit Indian PIN code, starting with 1–9.';
          input.focus();
          return;
        }
        message.textContent = 'PIN ' + pin + ': send your enquiry below and we will reply with the estimated delivery date before you order.';
        link.href = 'mailto:apnachizsupport@gmail.com?subject=' + encodeURIComponent('SafeCharge Pro delivery enquiry: ' + pin) + '&body=' + encodeURIComponent('Please confirm serviceability, dispatch timing, estimated delivery and COD availability for PIN code ' + pin + ' before I order SafeCharge Pro.');
        link.hidden = false;
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.querySelector('button').click();
        }
      });
    }
  });
}
